import { Spinner } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import styled from "styled-components";

export const sliceProps = (props, sub) => {
  const { children, ...otherProps } = props;
  sub.forEach((prop) => delete otherProps[prop]);
  return otherProps;
};
export const Box = styled.div`
  background-color: ${({ bg }) => (bg ? bg : "")};
`;
export const LazyImage = (props) => {
  return <LazyLoadImage className="custom-img" {...props} effect="blur" />;
};
export const IconBoxColor = styled.div`
  svg {
    [stroke] {
      stroke: ${({ iconColor }) => (iconColor ? iconColor : "")};
    }
  }
`;
export const Span = styled.span`
  background-color: ${({ bg }) => (bg ? bg : "")};
  font-size: ${(props) => (props.size ? props.size : "")};
  font-family: ${(props) => (props.family ? props.family : "var(--regular)")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arRegular)"};
  }
`;
export const SpanStyled = styled.span`
  width: ${(props) => (props.width ? props.width : "")};
  color: ${(props) => (props.color ? props.color : "")};
  border: ${(props) => (props.border ? `1px solid ${props.border}` : "")};
  border-radius: ${(props) => (props.radius ? props.radius : "")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-size: ${(props) => (props.size ? props.size : "16px")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  text-transform: ${(props) => (props.transform ? props.transform : "")};
  background-color: ${({ bg }) => (bg ? bg : "")};
  font-family: ${(props) => (props.family ? props.family : "var(--regular)")};
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arRegular)"};
  }
`;
export const HeadingStyled = styled.div`
  color: ${(props) => (props.color ? props.color : "var(--themeColor)")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-size: ${(props) => (props.size ? props.size : "20px")};
  display: ${(props) => (props.display ? props.display : "")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  text-transform: ${(props) => (props.transform ? props.transform : "")};
  /* font-family: ${(props) =>
    props.direction === "rtl" && props.family ? props.family : "var(--heavy)"},
                 ${(props) =>
    props.direction === "ltr" && props.family
      ? props.family
      : "var(--arExtraBold)"}; */
  /* font-family: ${({ lang }) =>
    lang === "en"
      ? "var(--heavy) !important"
      : "var(--arExtraBold) !important"}; */

  font-family: ${(props) => (props.family ? props.family : "var(--bold)")};
  body.rtl & {
    font-family: ${(props) => (props.family ? props.family : "var(--arBold)")};
  }
  @media (max-width: 767px) {
    font-size: 20px;
  }
`;
export const HeadingStyledSm = styled.div`
  color: ${(props) => (props.color ? props.color : "var(--themeColor)")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-size: ${(props) => (props.size ? props.size : "24px")};
  display: ${(props) => (props.display ? props.display : "")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  text-transform: ${(props) => (props.transform ? props.transform : "")};
  font-family: ${(props) => (props.family ? props.family : "var(--semiBold)")};
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arSemiBold)"};
  }
`;
export const HeadingStyledMd = styled.div`
  color: ${(props) => (props.color ? props.color : "var(--themeColor)")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-size: ${(props) => (props.size ? props.size : "30px")};
  display: ${(props) => (props.display ? props.display : "")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  text-transform: ${(props) => (props.transform ? props.transform : "")};
  font-family: ${(props) => (props.family ? props.family : "var(--heavy)")};
  body.rtl & {
    font-family: ${(props) => (props.family ? props.family : "var(--arBold)")};
  }
`;
export const HeadingStyledLg = styled.div`
  color: ${(props) => (props.color ? props.color : "var(--themeColor)")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-size: ${(props) => (props.size ? props.size : "40px")};
  display: ${(props) => (props.display ? props.display : "")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  text-transform: ${(props) => (props.transform ? props.transform : "")};
  font-family: ${(props) => (props.family ? props.family : "var(--heavy)")};
  body.rtl & {
    font-family: ${(props) => (props.family ? props.family : "var(--arBlack)")};
  }
`;
export const MainHeading = styled.div`
  color: ${(props) => (props.color ? props.color : "var(--themeColor)")};
  line-height: ${(props) => (props.lh ? props.lh : "normal")};
  font-size: ${(props) => (props.size ? props.size : "36px")};
  display: ${(props) => (props.display ? props.display : "")};
  width: ${(props) => (props.display ? props.display : "100%")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  text-transform: ${(props) => (props.transform ? props.transform : "")};
  font-family: ${(props) =>
      props.direction === "rtl" && props.family
        ? props.family
        : "var(--heavy)"},
    ${(props) =>
      props.direction === "ltr" && props.family
        ? props.family
        : "var(--arExtraBold)"};
`;

export const TextStyled = styled.p`
  display: ${(props) => (props.display ? props.display : "flex")};
  width: ${(props) => (props.display ? props.display : "100%")};
  line-height: ${(props) => (props.lh ? props.lh : "24px")};
  font-size: ${(props) => (props.size ? props.size : "16px")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  color: ${(props) => (props.color ? props.color : "var(--lightGrey)")};
  text-transform: ${(props) => (props.transform ? props.transform : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  background-color: ${({ bg }) => (bg ? bg : "")};
  font-family: ${(props) => (props.family ? props.family : "var(--regular)")};
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arRegular)"};
  }
`;
export const LabelStyled = styled.label`
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-size: ${(props) => (props.size ? props.size : "16px")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  letter-spacing: ${(props) => (props.spacing ? props.spacing : "")};
  color: ${(props) => (props.color ? props.color : "var(--darkGrey)")};
  position: relative;
  font-family: ${(props) => (props.family ? props.family : "var(--semiBold)")};
  span.optional {
    display: block;
    width: 100%;
    font-size: 14px;
    color: var(--text2);
    line-height: 16px;
  }
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arSemiBold)"};
  }
`;
export const ButtonStyledTb = styled.button`
  font-size: ${(props) => (props.size ? props.size : "16px")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  font-family: ${(props) => (props.family ? props.family : "var(--semiBold)")};
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.bg ? props.bg : "var(--themeColorSecondary)"};
  color: ${(props) => (props.color ? props.color : "var(--white)")};
  padding: ${(props) => (props.padding ? props.padding : "12px 20px")};
  border: 1px solid ${(props) => (props.border ? props.border : "transparent")};
  width: ${(props) => (props.width ? props.width : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  border-radius: 12px;
  transition: 0.3s ease-in-out opacity;
  letter-spacing: 0.8px;
  &:hover {
    opacity: 0.8;
  }
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arSemiBold)"};
  }
`;
export const ButtonDays = styled.button`
  font-size: ${(props) => (props.size ? props.size : "15px")};
  font-weight: ${(props) => (props.weight ? props.weight : "")};
  font-family: ${(props) => (props.family ? props.family : "var(--regular)")};
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.bg ? props.bg : "var(--bg)")};
  color: ${(props) => (props.color ? props.color : "var(--lightGrey2)")};
  padding: ${(props) => (props.padding ? props.padding : "12px 5px")};
  border: 1px solid
    ${(props) => (props.border ? props.border : "var(--border)")};
  width: ${(props) => (props.width ? props.width : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  border-radius: 12px;
  transition: 0.3s ease-in-out opacity;
  letter-spacing: 0.8px;
  width: 100%;
  &:hover {
    opacity: 0.8;
  }
  body.rtl & {
    font-family: ${(props) =>
      props.family ? props.family : "var(--arExtraLight)"};
  }
  &.active {
    background-color: var(--themeColorSecondary);
    border: 1px solid var(--themeColorSecondary);
    color: var(--white);
  }
`;
export const ButtonStyled = (props) => {
  const unwantedProps = [
    "icon",
    "label",
    "className",
    "clName",
    "onClick",
    "isLoading",
    "iconWidth",
    "iconAfter",
  ];
  // const buttonProps = props.type ? { href: props.type } : {};
  return (
    <ButtonWrapper
      width={props.width}
      {...sliceProps(props, unwantedProps)}
      className={`${props.clName ? props.clName : ""}`}
      disabled={props.disabled}
    >
      <button
        type={props.type && props.type}
        className={`d-flex align-items-center justify-content-center ${
          props.className || ""
        } ${!props.icon ? "Btn-icon" : ""} `}
        // {...buttonProps}
        onClick={props.onClick}
        autoComplete="false"
        disabled={props.disabled}
      >
        {props.isLoading ? (
          <Spinner variant="light" />
        ) : (
          <>
            {props.icon && (
              <props.icon width={props.iconWidth ? props.iconWidth : "20px"} />
            )}
            {props.label && (
              <SpanStyled size={props.size ? props.size : "16px"}>
                {props.label}
              </SpanStyled>
            )}
            {props.iconAfter && (
              <Box>
                <props.iconAfter
                  width={props.iconWidth ? props.iconWidth : ""}
                />
              </Box>
            )}

            {/* <SpanStyled size={props.size ? props.size : "16px"}>
              {props.label ? props.label : ""}
            </SpanStyled> */}
          </>
        )}
      </button>
    </ButtonWrapper>
  );
};
export const ButtonWrapper = styled.div`
  display: flex;
  width: ${({ width }) => (width ? width : "fit-content")};
  align-items: center;
  button,
  button::after {
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
  button {
    width: ${({ width }) => (width ? width : "")};
    background: ${(props) => (props.bg ? props.bg : "var(--themeColor)")};
    border: 1px solid
      ${(props) => (props.border ? props.border : "transparent")};
    display: flex;
    gap: 8px;
    padding: ${(props) => (props.padding ? props.padding : "11px 20px")};
    line-height: ${(props) => (props.lh ? props.lh : "1")};
    height: ${(props) => (props.height ? props.height : "40px")};
    position: relative;
    border-radius: ${(props) => (props.radius ? props.radius : "8px")};
    /* box-shadow: ${({ shadow }) =>
      shadow ? shadow : "0px 4px 8px 0px #064a9340"}; */
    span {
      text-wrap: nowrap;
      font-family: var(--semiBold);

      body.rtl & {
        font-family: ${(props) =>
          props.family ? props.family : "var(--arSemiBold)"};
      }
      color: ${(props) => (props.color ? props.color : "var(--white)")};
    }
    & svg {
      height: 20px;
      body.rtl & {
        transform: ${(props) => (props?.mirror ? "scaleX(-1)" : "")};
      }
      [fill] {
        fill: ${(props) => (props.iconColor ? props.iconColor : "")};
      }
    }
    /* &:hover {
      background: var(--hoverBg);
    } */
    ${(props) =>
      props.disabled &&
      `
        opacity: 0.5;
      `}
  }
`;
export const ButtonSecondary = (props) => {
  const unwantedProps = [
    "icon",
    "label",
    "className",
    "clName",
    "onClick",
    "isLoading",
    "iconWidth",
    "iconAfter",
  ];
  // const buttonProps = props.type ? { href: props.type } : {};
  return (
    <ButtonSecondaryWrapper
      {...sliceProps(props, unwantedProps)}
      className={`${props.clName ? props.clName : ""}`}
      disabled={props.disabled}
    >
      <button
        className={`d-flex align-items-center justify-content-center ${
          props.className || ""
        } ${!props.icon ? "Btn-icon" : ""} `}
        // {...buttonProps}
        onClick={props.onClick}
        autoComplete="false"
        disabled={props.disabled}
      >
        {props.isLoading ? (
          <Spinner variant="light" />
        ) : (
          <>
            {props.icon && (
              <props.icon width={props.iconWidth ? props.iconWidth : "20px"} />
            )}
            {props.label && (
              <SpanStyled size={props.size ? props.size : "16px"}>
                {props.label}
              </SpanStyled>
            )}
            {props.iconAfter && (
              <props.iconAfter width={props.iconWidth ? props.iconWidth : ""} />
            )}

            {/* <SpanStyled size={props.size ? props.size : "16px"}>
              {props.label ? props.label : ""}
            </SpanStyled> */}
          </>
        )}
      </button>
    </ButtonSecondaryWrapper>
  );
};
export const ButtonSecondaryWrapper = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  button,
  button::after {
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
  button {
    background: ${(props) => (props.bg ? props.bg : "var(--themeColor)")};
    border: 1px solid
      ${(props) => (props.border ? props.border : "transparent")};
    display: flex;
    gap: 8px;
    padding: ${(props) => (props.padding ? props.padding : "11px 20px")};
    line-height: ${(props) => (props.lh ? props.lh : "1")};
    height: ${(props) => (props.height ? props.height : "40px")};
    position: relative;
    border-radius: ${(props) => (props.radius ? props.radius : "8px")};
    /* box-shadow: ${({ shadow }) =>
      shadow ? shadow : "0px 4px 8px 0px #064a9340"}; */
    span {
      text-wrap: nowrap;
      font-family: var(--semiBold);

      body.rtl & {
        font-family: ${(props) =>
          props.family ? props.family : "var(--arSemiBold)"};
      }
      color: ${(props) => (props.color ? props.color : "var(--white)")};
    }
    & svg {
      height: 20px;
      [fill] {
        /* fill: var(--themeColor); */
      }
    }
    /* &:hover {
      background: var(--hoverBg);
    } */
    ${(props) =>
      props.disabled &&
      `
        opacity: 0.5;
      `}
  }
`;
export const FormButtonStyled = (props) => {
  const unwantedProps = [
    "icon",
    "label",
    "className",
    "clName",
    "onClick",
    "isLoading",
    "type",
  ];
  const buttonProps = props.type ? { href: props.type } : {};
  return (
    <FormButtonWrapper
      {...sliceProps(props, unwantedProps)}
      className={`${props.clName ? props.clName : ""}`}
      disabled={props.disabled}
    >
      <button
        className={`d-flex align-items-center justify-content-center ${
          props.className || ""
        } ${!props.icon ? "Btn-icon" : ""} `}
        {...buttonProps}
        onClick={props.onClick}
        autoComplete="false"
        disabled={props.disabled}
        type={props.type}
      >
        {props.isLoading ? (
          <Spinner variant="light" />
        ) : (
          <>
            <SpanStyled size={props.size ? props.size : "18px"}>
              {props.label ? props.label : ""}
            </SpanStyled>
            {props.icon && <props.icon width="22px" />}
          </>
        )}
      </button>
    </FormButtonWrapper>
  );
};
export const FormButtonWrapper = styled.div`
  display: flex;
  width: fit-content;
  button,
  button::after {
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
  button {
    background: ${(props) => (props.bg ? props.bg : "var(--themeColor)")};
    border: 1px solid
      ${(props) => (props.border ? props.border : "transparent")};
    display: flex;
    gap: 12px;
    height: 48px;
    padding: 0px 20px;
    position: relative;
    border-radius: 10px;
    box-shadow: ${(props) =>
      props.shadow ? props.shadow : "0px 4px 8px 0px #064a9340"};
    span {
      text-wrap: nowrap;
      /* font-family: var(--regular); */
      color: ${(props) => (props.color ? props.color : "var(--white)")};
    }
    & svg {
      height: 22px;
      [fill] {
        fill: var(--darkColor);
      }
    }
    /* &:hover {
      background: var(--hoverBg);
    } */
    ${(props) =>
      props.disabled &&
      `
    opacity: .7;
        // background: var(--themeColorSecondary);
        // color: var(--black);
        // cursor: not-allowed;
        
        // span {
        //   color: var(--black);
        // }

        // & svg [fill] {
        //   fill: var(--text2);
        // }
      `}
  }
`;

export const RoleStatus = (props) => {
  return (
    <PeopleMainRole>
      <SpanStyled color="var(--lightGrey)" size="14px">
        {props.status}
      </SpanStyled>
    </PeopleMainRole>
  );
};
export const PeopleMainRole = styled.div`
  display: flex;
  span {
    padding: 5px 16px;
    background-color: var(--bg);
    border-radius: 8px;
    border: 1px solid var(--border);
  }
`;
